import { api } from '../lib/api-client.js';

import type { CurrentUser } from '@sitewise/shared';


export async function updateProfile(input: { name?: string; email?: string }): Promise<{
  user: CurrentUser;
}> {
  return api<{ user: CurrentUser }>('/me', { method: 'PATCH', body: input });
}

export async function changePassword(input: {
  currentPassword: string;
  newPassword: string;
}): Promise<void> {
  await api('/me/password', { method: 'POST', body: input });
}

export interface TotpSetupResponse {
  secret: string;
  otpauthUrl: string;
  qrDataUrl: string;
}

export async function totpSetup(password: string): Promise<TotpSetupResponse> {
  return api<TotpSetupResponse>('/me/totp/setup', { method: 'POST', body: { password } });
}

export async function totpConfirm(input: { secret: string; code: string }): Promise<void> {
  await api('/me/totp/confirm', { method: 'POST', body: input });
}

export async function totpDisable(input: { password: string; code: string }): Promise<void> {
  await api('/me/totp/disable', { method: 'POST', body: input });
}

export interface NotificationPreference {
  category: string;
  channelEmail: boolean;
  channelSms: boolean;
  channelInApp: boolean;
  digestFrequency: 'realtime' | 'daily' | 'weekly';
  urgentOverridesDigest: boolean;
  emailUnsubscribed: boolean;
}

export interface QuietHours {
  enabled: boolean;
  startLocalTime: string;
  endLocalTime: string;
  timezone: string;
  urgentOverrides: boolean;
}

export async function fetchNotificationPreferences(): Promise<{
  preferences: NotificationPreference[];
  quietHours: QuietHours;
}> {
  return api<{ preferences: NotificationPreference[]; quietHours: QuietHours }>(
    '/me/notification-preferences',
  );
}

export async function updateNotificationPreferences(input: {
  preferences: NotificationPreference[];
}): Promise<void> {
  await api('/me/notification-preferences', { method: 'PUT', body: input });
}

export async function updateQuietHours(input: QuietHours): Promise<void> {
  await api('/me/notification-preferences/quiet-hours', { method: 'PUT', body: input });
}

export async function startPhoneVerification(phone: string): Promise<{
  phone: string;
  expiresAt: string;
}> {
  return api<{ phone: string; expiresAt: string }>('/me/phone/verify-start', {
    method: 'POST',
    body: { phone },
  });
}

export async function confirmPhoneVerification(code: string): Promise<void> {
  await api('/me/phone/verify-confirm', { method: 'POST', body: { code } });
}

export async function removePhone(): Promise<void> {
  await api('/me/phone/remove', { method: 'POST' });
}
